module.exports = __webpack_public_path__ + "static/img/logo-header.93b8149a.png";